<template>
    <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-40" :class="{ 'hidden': !isBlur }" @click="handleOverlayClick"></div>
    <section
        class="bg-color-top-bar shadow-lg dark:bg-dark-900 px-6 py-4 border-b border-primary dark:border-dark-500 flex justify-between items-center w-full z-40 h-[70px] fixed">
        <div class="flex items-center">
            <div id="open-sidebar" class="flex flex-col w-8 h-5 justify-between cursor-pointer me-5 group"
                @click="toggleSidebar">
                <span id="hamburger_item"
                    class="bg-primary dark:bg-dark-100 rounded-full transition-all duration-200"></span>
                <span id="hamburger_item"
                    class="bg-primary dark:bg-dark-100 rounded-full transition-all duration-200"></span>
                <span id="hamburger_item"
                    class="bg-primary dark:bg-dark-100 rounded-full transition-all duration-200"></span>
            </div>
            <div>
                <RouterLink id="btn-top-bar-home" to="/dashboard"
                    class="bg-primary dark:bg-primary text-light-50 dark:text-dark-50 px-4 py-2 rounded-lg flex items-center font-medium hover:opacity-90 transition-opacity duration-200">
                    <HomeIcon class="h-5 w-5 text-light-50 dark:text-dark-50 me-2" /> Beranda
                </RouterLink>
            </div>
            <div v-if="outlet_name" class="ml-4">
                <h1 class="bg-info text-light-50 dark:text-dark-50 px-2 py-1 rounded-lg font-bold">{{ outlet_name }}</h1>
            </div>
            <div class="ml-4">
                <Button icon="pi pi-refresh" rounded size="small" text @click="refresh" severity="secondary" />
            </div>
        </div>
        <div class="flex items-center gap-4">
            <!-- Dark Mode Toggle -->
            <button id="btn-dark-mode" @click="toggleDarkMode"
                class="p-2 rounded-lg hover:bg-light-200 dark:hover:bg-dark-700 transition-colors duration-200">
                <MoonIcon v-if="isDarkMode" class="h-6 w-6 text-light-700 dark:text-dark-50" />
                <SunIcon v-else class="h-6 w-6 text-light-500 dark:text-dark-50" />
            </button>
            <div class="profile relative">
                <span class="flex items-center">
                    <div id="profile-button" @click="toggleProfileDropdown" class="cursor-pointer">
                        <UserCircleIcon
                            class="h-10 w-10 bg-light-100 dark:bg-dark-100 rounded-full transition-opacity duration-200 hover:opacity-90" />
                    </div>
                </span>
                <div v-if="isProfileDropdownOpen"
                    class="absolute right-0 mt-2 w-48 bg-light-50 dark:bg-dark-800 border border-gold-500/20 rounded-lg shadow-lg z-50 animate__animated overflow-hidden"
                    :class="{ 'animate__zoomIn': isProfileDropdownOpen, 'animate__animated animate__fadeOut': !isProfileDropdownOpen }">
                    <RouterLink id="url-profile" to="/profil"
                        class="px-4 py-3 text-sm flex hover:bg-gold-100/10 text-dark-800 dark:text-light-100 transition-colors duration-200">
                        <UserIcon class="me-2 h-4 w-4" /> Profil
                    </RouterLink>
                    <button id="logout" @click="logout"
                        class="w-full flex text-left px-4 py-3 text-sm hover:bg-gold-100/10 text-dark-800 dark:text-light-100 transition-colors duration-200">
                        <ArrowRightOnRectangleIcon class="h-4 w-4 me-2" /> Logout
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { UserCircleIcon, UserIcon, ArrowRightOnRectangleIcon, HomeIcon, SunIcon, MoonIcon } from '@heroicons/vue/24/solid';
import { Button } from 'primevue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'TopBar',
    components: {
        UserCircleIcon, UserIcon, ArrowRightOnRectangleIcon, HomeIcon, SunIcon, MoonIcon, Button
    },
    data() {
        return {
            isProfileDropdownOpen: false,
            isBlur: false,
            outlet_id: localStorage.getItem('outlet_id'),
        }
    },
    computed: {
        ...mapGetters('darkMode', ['isDarkMode']),
        ...mapGetters('outlets', ['allOutlets']),
        outlet_name() {
            const outlet = this.allOutlets.find(outlet => outlet.id == this.outlet_id);
            return outlet ? outlet.name : false;
        }
    },
    methods: {
        ...mapActions('darkMode', ['toggleDarkMode', 'initDarkMode']),
        toggleSidebar() {
            this.$parent.$refs.sidebar?.toggleSidebar();
        },
        toggleProfileDropdown() {
            this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
        },
        closeProfileDropdown() {
            this.isProfileDropdownOpen = false;
        },
        handleOverlayClick() {
            this.$parent.$refs.sidebar?.closeSidebar();
        },
        logout() {
            localStorage.clear();
            this.$router.push('/');
        },
        refresh() {
            this.$router.go(0);
        }
    },
    mounted() {
        this.initDarkMode();
        this.$store.dispatch('outlets/fetchOutlets');
    },
}
</script>

<style>
#hamburger_item {
    height: 3px;
}
</style>